export const OverallDimensionsInformationFieldNames = {
  OverallLength: 'overallLength',
  OverallHeight: 'overallHeight',
  OverallWidth: 'overallWidth',
  OverallWeight: 'overallWeight',
  OverallFrontOverhang: 'overallFrontOverhang',
  OverallRearOverhang: 'overallRearOverhang',
  OverallEFFOverhang: 'overallEFFOverhang',
} as const;

export type OverallDimensionsInformationFields = {
  [OverallDimensionsInformationFieldNames.OverallLength]?: number | string;
  [OverallDimensionsInformationFieldNames.OverallHeight]?: number | string;
  [OverallDimensionsInformationFieldNames.OverallWidth]?: number | string;
  [OverallDimensionsInformationFieldNames.OverallWeight]?: number;
  [OverallDimensionsInformationFieldNames.OverallFrontOverhang]?:
    | number
    | string;
  [OverallDimensionsInformationFieldNames.OverallRearOverhang]?:
    | number
    | string;
  [OverallDimensionsInformationFieldNames.OverallEFFOverhang]?: number | string;
};
